import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = 'white'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#696969',
        backgroundColor: '#696969',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 15,
        fontFamily:'Helvetica-Bold',
        fontSize:7,
        color:'white',
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,

    },
    description: {
        width: '25%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    sn: {
        width: '5%',
    },
    qty: {
        width: '10%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    rate: {
        width: '30%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    amount: {
        width: '20%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    prev1: {
        width: '10%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    }
  });

  const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.sn}>S/N</Text>
        <Text style={styles.description}>Test Name</Text>
        <Text style={styles.qty}>Test Code</Text>
        <Text style={styles.rate}>Sample Type</Text>
        <Text style={styles.amount}>Delivery Time</Text>
        <Text style={styles.prev1}>Test Price</Text>
  
    </View>
  );
  
  export default InvoiceTableHeader